<div class="login-page">
  <div class="login-form">
    <div class="form-container">
      <h2>Login</h2>
     

      <form [formGroup]="loginForm" (ngSubmit)="getlogin()" >
        
        <div class="form-group">
          <label for="username">UserName</label>
          <input id="username" type="text" formControlName="username"    [(ngModel)]="add.UserName" placeholder="Enter UserName" />
          
        </div>

      
        <div class="form-group">
          <label for="password">Password</label>
          <div class="password-wrapper">
            <input id="password" [type]="hidePassword ? 'password' : 'text'" [(ngModel)]="add.Password" formControlName="password" />
            
          </div>
          
        </div>

        
        <button type="submit" class="submit-btn" >Login</button>

        
        <div class="links">
        
        </div>
      </form>
    </div>
  </div>
</div>
